import { SxProps } from '@mui/material';

export const accordionRootSx: SxProps = {
    '& .Mui-expanded': {
        margin: 'initial',
        minHeight: 'initial',
    },
    '&:before': {
        display: 'none',
    },
    boxShadow: 'none',
};

export const accordionSummarySx: SxProps = {
    '& > div': {
        m: 0,
    },
    p: 0,
};

export const accordionSwitchSx: SxProps = {
    mt: 1,
};
